import React, { Fragment, useState, useMemo } from 'react';
import { object, string } from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import qs from 'qs';

import BtnPrint from 'components/BtnPrint';
import SocialShareButton from 'components/SocialShareButton';

import { withLabels } from 'containers/withLabels';
import { withSearchContext } from 'containers/withSearchContext';

import { isGlobalSite } from 'utils/currentLanguage';

import IconArrowRight from 'media/icons/arrow-right-long.icon.svg';
import styles from './TopProductControls.module.scss';
const cx = classNames.bind(styles);

// @todo: Refactor back-btn. Need to use Button component.
const TopProductControls = ({
  labels,
  pageTitle,
  searchHistory,
  action,
  contextSearch: { partName, carName },
}) => {
  const [isShownSharing, setIsShownSharing] = useState(false);

  const currentHref = useMemo(() => {
    const { search: searchValue, country } = qs.parse(searchHistory, {
      ignoreQueryPrefix: true,
    });
    const countryValue = country && isGlobalSite ? '?country=' + country : '';

    return searchHistory && searchHistory.length && action !== 'POP'
      ? `/search${countryValue}${searchValue ? `#${searchValue}` : ''}`
      : '/';
  }, [searchHistory, isGlobalSite]);

  return (
    <div className={cx('top-info', { 'show-sharing': isShownSharing })}>
      <Link className={cx('back-btn')} to={currentHref}>
        <span className={cx('btn-icon', 'icon-arrow')}>
          <IconArrowRight />
        </span>
        <span className={cx('btn-text')}>{labels.productButtonBackText}</span>
      </Link>

      <span className={cx('search-result')}>
        {!!partName && !!carName && (
          <Fragment>
            ‘‘
            {partName} - {carName}
            ’’
          </Fragment>
        )}
      </span>

      <SocialShareButton
        isShownSharing={isShownSharing}
        pageTitle={pageTitle}
        setIsShownSharing={setIsShownSharing}
      />
      <BtnPrint />
    </div>
  );
};

TopProductControls.propTypes = {
  labels: object.isRequired,
  pageTitle: string,
  contextSearch: object.isRequired,
};

TopProductControls.defaultProps = {
  pageTitle: null,
};

export default withLabels(withSearchContext(TopProductControls));



// WEBPACK FOOTER //
// ./src/pages/Product/components/TopProductControls/TopProductControls.js